/*! UIkit 2.23.0 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
/*! CUSTOM VERSION */

(function (addon) {

    "use strict";
    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-autocomplete", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function (UI){

    "use strict";

    var active;

    UI.component('autocomplete', {

        defaults: {
            minLength: 3,
            param: 'search',
            method: 'post',
            delay: 100,
            loadingClass: 'uk-loading',
            flipDropdown: false,
            skipClass: 'uk-skip',
            hoverClass: 'uk-active',
            source: null,
            renderer: null,
            type: null,
            template: '<ul class="uk-nav uk-nav-autocomplete uk-autocomplete-results">{{~items}}<li data-id="{{$item.id}}" data-value="{{$item.value}}"><a>{{$item.value}}</a></li>{{/items}}</ul>'
        },
        visible  : false,
        value    : null,
        selected : null,

        boot: function () {

            // init code
            UI.$html.on("focus.autocomplete.uikit", "[data-uk-autocomplete]", function (e) {
                var ele = UI.$(this);
                if (!ele.data("autocomplete")) {
                    UI.autocomplete(ele, UI.Utils.options(ele.attr("data-uk-autocomplete")));
                }
            });

            // register outer click for autocompletes
            UI.$html.on("click.autocomplete.uikit", function (e) {
                if (active && e.target!=active.input[0]) active.hide();
            });
        },

        init: function() {
            var $this   = this,
                select  = false,
                trigger = UI.Utils.debounce(function(e) {
                    if(select) {
                        return (select = false);
                    }
                    $this.handle();
                }, this.options.delay);

            this.dropdown = this.find('.uk-dropdown');
            this.template = this.find('script[type="text/autocomplete"]').html();
            this.template = UI.Utils.template(this.template || this.options.template);
            this.input    = this.find("input:first").attr("autocomplete", "off");
            this.fields = {};
            if (this.options.target) {
                this.fields.id = UI.$html.find("#" + this.options.target + "_id");
                this.fields.firstname = UI.$html.find("#" + this.options.target + "_firstname");
                this.fields.lastname = UI.$html.find("#" + this.options.target + "_lastname");
                this.fields.address = UI.$html.find("#" + this.options.target + "_address");
                this.fields.postcode = UI.$html.find("#" + this.options.target + "_postcode");
                this.fields.city = UI.$html.find("#" + this.options.target + "_city");
                this.fields.province = UI.$html.find("#" + this.options.target + "_province");
                this.fields.country_code = UI.$html.find("#" + this.options.target + "_country_code");
                this.fields.email = UI.$html.find("#" + this.options.target + "_email");
                this.fields.birth_date = UI.$html.find("#" + this.options.target + "_birth_date");
                this.fields.tax_code = UI.$html.find("#" + this.options.target + "_tax_code");
                this.fields.phone_number = UI.$html.find("#" + this.options.target + "_phone_number");
                this.fields.document_id = UI.$html.find("#" + this.options.target + "_document_id");
                this.fields.document_id_span = UI.$html.find("#" + this.options.target + "_document_id").closest('div').find('span');
                this.fields.document_number = UI.$html.find("#" + this.options.target + "_document_number");
                this.fields.companyname = UI.$html.find("#" + this.options.target + "_companyname");
                this.fields.attorney = UI.$html.find("#" + this.options.target + "_attorney");
                this.fields.vat_number = UI.$html.find("#" + this.options.target + "_vat_number");
                this.fields.type = UI.$html.find("#" + this.options.target + "_type");

                if (this.options.target=='guest') {
                    this.fields.invoice_tag = UI.$html.find("#" + this.options.target + "_registered_invoice");
                    this.fields.email_pec = UI.$html.find("#" + this.options.target + "_email_pec");
                    this.fields.einvoice_destination_code = UI.$html.find("#" + this.options.target + "_einvoice_destination_code");
                } else if (this.options.target=='host') {
                    this.fields.iban = UI.$html.find("#" + this.options.target + "_iban");
                }
            }
            this.storeid  = this.find("input").eq(1);
            if (!this.dropdown.length) {
               this.dropdown = UI.$('<div class="uk-dropdown"></div>').appendTo(this.element);
            }
            if (this.options.flipDropdown) {
                this.dropdown.addClass('uk-dropdown-flip');
            }
            this.dropdown.attr('aria-expanded', 'false');
            this.input.on({
                "keydown": function(e) {
                    if (e && e.which && !e.shiftKey) {
                        switch (e.which) {
                            case 13: // enter
                                select = true;
                                if ($this.selected) {
                                    e.preventDefault();
                                    $this.select();
                                }
                                break;
                            case 38: // up
                                e.preventDefault();
                                $this.pick('prev', true);
                                break;
                            case 40: // down
                                e.preventDefault();
                                $this.pick('next', true);
                                break;
                            case 27:
                            case 9: // esc, tab
                                $this.hide();
                                break;
                            default:
                                break;
                        }
                    }

                },
                "keyup": trigger
            });

            this.dropdown.on("click", ".uk-autocomplete-results > *", function(){
                $this.select();
            });

            this.dropdown.on("mouseover", ".uk-autocomplete-results > *", function(){
                $this.pick(UI.$(this));
            });

            this.triggercomplete = trigger;

        },

        handle: function() {
            var $this = this, old = this.value;
            this.value = this.input.val();
            if (this.value.length < this.options.minLength) return this.hide();
            if (this.value != old) {
                $this.request();
            }
            return this;
        },

        pick: function(item, scrollinview) {
            var $this    = this,
                items    = UI.$(this.dropdown.find('.uk-autocomplete-results').children(':not(.'+this.options.skipClass+')')),
                selected = false;
            if (typeof item !== "string" && !item.hasClass(this.options.skipClass)) {
                selected = item;
            } else if (item == 'next' || item == 'prev') {
                if (this.selected) {
                    var index = items.index(this.selected);
                    if (item == 'next') {
                        selected = items.eq(index + 1 < items.length ? index + 1 : 0);
                    } else {
                        selected = items.eq(index - 1 < 0 ? items.length - 1 : index - 1);
                    }
                } else {
                    selected = items[(item == 'next') ? 'first' : 'last']();
                }
                selected = UI.$(selected);
            }
            if (selected && selected.length) {
                this.selected = selected;
                items.removeClass(this.options.hoverClass);
                this.selected.addClass(this.options.hoverClass);
                this.datafiltered = this.data[items.index(this.selected)];
                // jump to selected if not in view
                if (scrollinview) {
                    var top       = selected.position().top,
                        scrollTop = $this.dropdown.scrollTop(),
                        dpheight  = $this.dropdown.height();
                    if (top > dpheight ||  top < 0) {
                        $this.dropdown.scrollTop(scrollTop + top);
                    }
                }
            }
        },

        select: function() {
            if(!this.selected) return;
            var data = this.selected.data();
            this.trigger("selectitem.uk.autocomplete", [data, this]);
            if (data.value) {
                this.input.val(data.value).trigger('change');
                if (this.options.target) {
                    this.fields.id.val(this.datafiltered.id);
                    this.fields.firstname.val(this.datafiltered.firstname);
                    this.fields.lastname.val(this.datafiltered.lastname);
                    this.fields.address.val(this.datafiltered.address);
                    this.fields.postcode.val(this.datafiltered.postcode);
                    this.fields.city.val(this.datafiltered.city);
                    this.fields.province.val(this.datafiltered.province);
                    this.fields.country_code.val(this.datafiltered.country_code).change();
                    this.fields.email.val(this.datafiltered.email);
                    this.fields.birth_date.val(this.datafiltered.birth_date);
                    this.fields.tax_code.val(this.datafiltered.tax_code);
                    this.fields.phone_number.val(this.datafiltered.phone_number);
                    this.fields.document_id.val(this.datafiltered.document_id).change();
                    this.fields.document_number.val(this.datafiltered.document_number);
                    this.fields.companyname.val(this.datafiltered.companyname);
                    this.fields.attorney.val(this.datafiltered.attorney);
                    this.fields.type.val(this.datafiltered.type);
                    this.fields.vat_number.val(this.datafiltered.vat_number);
                    if (this.datafiltered.type=='H') {
                        this.fields.companyname.attr("disabled", "disabled");
                        this.fields.attorney.attr("disabled", "disabled");
                        this.fields.vat_number.attr("disabled", "disabled");
                        this.fields.birth_date.removeAttr("disabled");
                        this.fields.tax_code.removeAttr("disabled");
                    } else {
                        this.fields.companyname.removeAttr("disabled");
                        this.fields.attorney.removeAttr("disabled");
                        this.fields.vat_number.removeAttr("disabled");
                    }
                    if (this.options.target=='guest') {
                        this.fields.invoice_tag.prop('checked', this.datafiltered.invoice_tag==1 ? true : false);
                        this.fields.invoice_tag.val(this.datafiltered.invoice_tag);
                        this.fields.email_pec.val(this.datafiltered.email_pec);
                        this.fields.einvoice_destination_code.val(this.datafiltered.einvoice_destination_code);

                        if (this.datafiltered.type=='H') {
                            this.fields.invoice_tag.attr("disabled", "disabled");
                        } else {
                            this.fields.invoice_tag.removeAttr("disabled");
                        }
                    } else if (this.options.target=='host') {
                        this.fields.iban.val(this.datafiltered.iban);
                    }
                    $(document).guardian();
                    this.storeid.val(data.id);
                }
            }
            this.hide();
        },

        show: function() {
            if (this.visible) return;
            this.visible = true;
            this.element.addClass("uk-open");
            if (active && active!==this) {
                active.hide();
            }
            active = this;
            // Update aria
            this.dropdown.attr('aria-expanded', 'true');
            return this;
        },

        hide: function() {
            if (!this.visible) return;
            this.visible = false;
            this.element.removeClass("uk-open");

            if (active === this) {
                active = false;
            }

            // Update aria
            this.dropdown.attr('aria-expanded', 'false');

            return this;
        },

        request: function() {
            var $this   = this,
                release = function(data) {
                    if(data) {
                        $this.render(data);
                    }
                    $this.element.removeClass($this.options.loadingClass);
                };

            this.element.addClass(this.options.loadingClass);

            if (this.options.source) {
                var source = this.options.source;

                switch(typeof(this.options.source)) {
                    case 'function':
                        this.options.source.apply(this, [release]);
                        break;

                    case 'object':
                        if(source.length) {
                            var items = [];
                            source.forEach(function(item){
                                if(item.value && item.value.toLowerCase().indexOf($this.value.toLowerCase())!=-1) {
                                    items.push(item);
                                }
                            });
                            release(items);
                        }
                        break;

                    case 'string':
                        var params ={};
                        params[this.options.param] = this.value;
                        var token = $('meta[name="csrf-token"]').attr('content');
                        UI.$.ajax({
                            beforeSend: function (xhr) {
                                return xhr.setRequestHeader('X-XSRF-Token', token);
                            },
                            url: this.options.source,
                            data: params,
                            type: this.options.method,
                            dataType: 'json'
                        }).done(function(json) {
                            release(json || []);
                        });
                        break;

                    default:
                        release(null);
                }

            } else {
                this.element.removeClass($this.options.loadingClass);
            }
        },

        render: function(data) {
            this.dropdown.empty();
            this.selected = false;
            if (this.options.renderer) {
                this.options.renderer.apply(this, [data]);
            } else if(data && data.length) {
                this.data = data; //inserisco il dato perché lo script elimina i campi che non conosce
                this.dropdown.append(this.template({"items":data}));
                this.show();
                this.trigger('show.uk.autocomplete');
            }
            return this;
        }
    });

    return UI.autocomplete;
});
